import React from "react";
import { StyledLabel, StyledSelectInput } from "@aureskonnect/react-ui";
import { AvGroup } from "availity-reactstrap-validation";
import classnames from "classnames";

import { MONETIC_MARK_OPTIONS } from "@constants/index";

import { useMoneticsForm } from "../MoneticsFormContext";
import { FieldError } from "./FieldError";

/** "Monetic type" select used to pick the payment brand. */
export function MarkSelectField() {
    const { form, props } = useMoneticsForm();
    const { t, mark, handleOnChangeMark } = form;
    const { selectMark, editedData, isConsult } = props;

    return (
        <AvGroup>
            <StyledLabel htmlFor="text" className="required__clz mt-3">
                {t("Monetic type")}
            </StyledLabel>
            <StyledSelectInput
                className={classnames("mnt_inp_mark", {
                    invalid__clz: selectMark,
                    "not-allowed-input__clz": editedData.Id !== undefined,
                    readOnly__clz: isConsult,
                })}
                data-testid="monetics-mark-select"
                placeholder={t("Select")}
                onChange={async (e: any) => {
                    handleOnChangeMark(e);
                }}
                options={MONETIC_MARK_OPTIONS}
                value={mark === "" ? null : { label: mark, value: mark }}
                name="mark"
                noOptionsMessage={() => t("No options")}
            />
            {selectMark ? (
                <FieldError>{t("Please select a mark")}</FieldError>
            ) : null}
        </AvGroup>
    );
}
